(() => {
  function applyFontSizeMultipliers(radioInput) {
    document.documentElement.style.setProperty('--title-multiplier', radioInput.dataset.titleMultiplier)
    document.documentElement.style.setProperty('--copy-multiplier', radioInput.dataset.copyMultiplier)
    document.documentElement.style.setProperty('--smalltext-multiplier', radioInput.dataset.smalltextMultiplier)
  }

  const switchers = document.querySelectorAll('.font-size-switcher')
  switchers.forEach((switcher, i) => {
    const radioInputs = switcher.querySelectorAll('input[type="radio"]')
    radioInputs.forEach(radioInput => {
      radioInput.setAttribute('name', `${radioInput.getAttribute('name')}-${i}`)
      radioInput.addEventListener('change', () => {
        applyFontSizeMultipliers(radioInput)
        localStorage.setItem('font-size', radioInput.value)
      })
    })
    const storedState = localStorage.getItem('font-size') || 'normal'
    if (storedState) {
      const radioInput = switcher.querySelector(`[value="${storedState}"]`)
      if (radioInput) {
        radioInput.checked = true
        applyFontSizeMultipliers(radioInput)
      }
    }
  })
})()
